<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="{{ 'inventory.title' | translate }}" [backWithParams]="true">
  <ng-template #addButton>
    <div class="d-flex search-field">

      <div class="create_btn_sd">
        <button mat-flat-button color="primary" mat-button aria-label="option menu"
        [matMenuTriggerFor]="menu">
            <mat-icon>add</mat-icon> 
            Activity
        </button>
    </div>

      <!-- <button mat-button aria-label="option menu"
      [matMenuTriggerFor]="menu" color="accent" >
      <mat-icon class="material-icons-round try" [inline]="true">add_circle</mat-icon>
      </button> -->

      <mat-menu #menu="matMenu">
        <button  mat-menu-item (click)="onRecordUsage()" >
          <mat-icon class="material-icons-outlined">done</mat-icon>
          <span>{{ 'inventory.op1_record_usage' | translate }}</span>
        </button>
        <button  mat-menu-item (click)="OnIncreaseStock()" [disabled]="!isOwner">
          <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
          <span>{{ 'inventory.op2_increase_stock' | translate }}</span>
        </button>
       
      </mat-menu>
    </div>
  </ng-template>
</sm-title-bar>

<!-- <div style="background: #ffc107; border-radius: 4px; margin: 40px 0 30px;" (click)="openInventoryItems()" *ngIf="!loader">
  <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;">
    <div class="book_text" style="padding: 16px !important;">
        <div class="entry_sec">
            <mat-icon style="color:#222;position: relative;
            top: 9px;">navigate_next</mat-icon>
        </div>
        <p style="color:black;    font-size: 20px;    margin: 0 0 5px;

        font-weight: 500;" >{{ 'inventory.banner_txt1' | translate }}</p>
        <span>{{ 'inventory.banner_txt2' | translate }}</span>
    </div>
</div>
</div>  -->


<div class="bradcamp_inventory"  *ngIf="!loader">
<div class="row">
  <div class="col-sm-3">
    <div class="overall_count_s">
    <p>Overall count</p>
    <h3>{{inventoryStatus.total_items_count}}</h3>
    </div>
  </div>
  <div class="col-sm-3">
    <div class="overall_count_s">
    <p>Out of stock</p>
    <h3>{{inventoryStatus.out_of_stock_count}}</h3>
    </div>
  </div>
  <div class="col-sm-3">
    <div class="overall_count_s" style="border-right: none !important;">
    <p>Minimum stock</p>
    <h3>{{inventoryStatus.low_stock_count}}</h3>
    </div>
  </div>
  <div class="col-sm-3">
    <div class="view_items_btn">
      <button mat-flat-button color="primary" mat-button aria-label="option menu" (click)="openInventoryItems()">
        View all items
      </button>
    </div>
  </div>
</div>
</div>



<mat-card *ngIf="!loader && inventoryActivityData.length > 0">
  <sm-title-bar pageSubTitle="Inventory Activity"></sm-title-bar>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumn" [dataSource]="inventoryActivityData" [showImageColumn]="true"  [imageTemplate]="image" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"></sm-data-table>
  </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue >
  
  <button mat-menu-item (click)="onRevertUsage(rowvalue)" [disabled]="checkDisablity(rowvalue)">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span>{{ 'inventory.op1_revert_usage' | translate }}</span>
  </button>
  
</ng-template>

<ng-template #image let-objValue>
  <div style="position: relative;">
    <img
      [src]="
        objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
          ? objValue['image_thumb_url']
          : '../../../../assets/images/photo.png'
      "
      class="img-fluid rounded-circle" style="border: 1px solid lightgray;"
    />
    
    <mat-icon style="height: 20px;
    width: 20px;
    border-radius: 50%;
    display: block;
    position: absolute;
    bottom: -5px;
    font-size: 20px !important;
    left: 25px;
    background-color: green;
    color: white;" *ngIf="objValue['operation_type'] == 1" class="material-icons-round">arrow_downward</mat-icon>
    <mat-icon style="height: 20px;
    width: 20px;
    border-radius: 50%;
    display: block;
    position: absolute;
    bottom: -5px;
    font-size: 20px !important;
    left: 25px;
    background-color: red;
    color: white;" *ngIf="objValue['operation_type'] == 2" class="material-icons-round"> arrow_upward</mat-icon>
    </div>
</ng-template>

<mat-paginator
*ngIf="!loader && inventoryActivityData.length > 0"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>



<!-- <ng-container>

  <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>
  
      <h3>
        Inventory items are coming
      </h3>
      <p>
        We are working hard day and night to bring this for you.
      </p>
    </div>
  </div>   
</ng-container> -->


  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && inventoryActivityData.length == 0">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/statistics-reports.jpg">
                 </div>
                 <mat-card-title>No inventory activity</mat-card-title>
                 <mat-card-content>There's no inventory In or Out activity here. Once you start adding purchase and finish records, they'll appear here.
                </mat-card-content>
                 <div class="watch_vc_btn">
                  <button mat-flat-button color="primary" mat-button aria-label="option menu"
                  [matMenuTriggerFor]="menu">
                      <mat-icon>add</mat-icon> 
                      Activity
                  </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/inventory-activity.png">
                 </div>
                 <mat-card-title>What is inventory activity?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on inventory activity related to new purchase, increase stock and record finish of inventory item.
                </mat-card-content>
                 <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" >
                    <mat-icon>help</mat-icon>
                   See help doc
                 </button>
                 <mat-menu #menu="matMenu" >
                  <button  mat-menu-item (click)="onRecordUsage()" >
                    <mat-icon class="material-icons-outlined">check_small</mat-icon>
                    <span>{{ 'inventory.op1_record_usage' | translate }}</span>
                  </button>
                  <button  mat-menu-item (click)="OnIncreaseStock()" [disabled]="!isOwner">
                    <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
                    <span>{{ 'inventory.op2_increase_stock' | translate }}</span>
                  </button>
                 
                </mat-menu>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding inventory activity record or in getting incorrect activity data, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->